module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/mobile-stacked-2-image-1-1-314f81e4417119b9d40fb92ac942279c.png";